import React, { memo, SVGProps } from 'react'

export const StatusUpcoming = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 15C16.792 15 15 16.792 15 19C15 21.208 16.792 23 19 23C21.208 23 23 21.208 23 19C23 16.792 21.2 15 19 15ZM20.984 19.6H19C18.672 19.6 18.4 19.328 18.4 19V16.584C18.4 16.256 18.672 15.984 19 15.984C19.328 15.984 19.6 16.256 19.6 16.584V18.4H20.984C21.312 18.4 21.584 18.672 21.584 19C21.584 19.328 21.312 19.6 20.984 19.6Z"
      fill="#FDA203"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.112 19.0613C14.112 16.3307 16.32 14.1227 19.0507 14.1227C20.7787 14.1227 22.2827 15.008 23.168 16.3413C23.6907 14.9973 23.9893 13.536 23.9893 12C24 5.376 18.624 0 12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C13.536 24 14.9867 23.7013 16.3413 23.1787C15.008 22.2933 14.1227 20.7787 14.1227 19.0613H14.112ZM10.8693 16.0533C10.72 16.2027 10.5173 16.288 10.304 16.288C10.0907 16.288 9.888 16.2027 9.73867 16.0533L6.15467 12.4693C5.84533 12.16 5.84533 11.648 6.15467 11.3387C6.464 11.0293 6.976 11.0293 7.28533 11.3387L10.304 14.3573L16.704 7.95733C17.0133 7.648 17.5253 7.648 17.8347 7.95733C18.144 8.26667 18.144 8.77867 17.8347 9.088L10.8693 16.0533Z"
      fill="currentColor"
    />
  </svg>
))
